import { render, staticRenderFns } from "./params.vue?vue&type=template&id=53297155&scoped=true"
import script from "./params.vue?vue&type=script&lang=js"
export * from "./params.vue?vue&type=script&lang=js"
import style0 from "./params.vue?vue&type=style&index=0&id=53297155&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53297155",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53297155')) {
      api.createRecord('53297155', component.options)
    } else {
      api.reload('53297155', component.options)
    }
    module.hot.accept("./params.vue?vue&type=template&id=53297155&scoped=true", function () {
      api.rerender('53297155', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/template/components/params.vue"
export default component.exports